import React from 'react';
import { Box, Typography } from '@mui/material';
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';

interface ProductivityAppsWarningBannerProps {
  hasProductivityApps: boolean | null;
  customerConnectedToTheo?: boolean | null;
  compact?: boolean;
}

export const ProductivityAppsWarningBanner: React.FC<ProductivityAppsWarningBannerProps> = ({
  hasProductivityApps,
  customerConnectedToTheo = null,
  compact = false,
}) => {
  const isCustomerMissing = customerConnectedToTheo === false;

  if (!isCustomerMissing && (hasProductivityApps === null || hasProductivityApps === true)) {
    return null;
  }

  return (
    <Box
      sx={{
        mb: compact ? 1 : 1.5,
        p: compact ? 1 : 1.5,
        borderRadius: 2,
        border: '1px solid #DC2626',
        backgroundColor: 'rgba(220, 38, 38, 0.08)',
        display: 'flex',
        alignItems: 'flex-start',
        gap: 1.5,
      }}
    >
      <WarningAmberOutlinedIcon
        sx={{
          color: '#DC2626',
          fontSize: compact ? '1.25rem' : '1.5rem',
          mt: compact ? 0.25 : 0.5,
          flexShrink: 0,
        }}
      />
      <Typography
        variant="body2"
        sx={{
          color: '#991B1B',
          lineHeight: 1.5,
          fontWeight: 500,
        }}
      >
        {isCustomerMissing ? (
          <>
            This customer is not connected to Theo. Connect the customer in{' '}
            <Typography
              component="span"
              variant="inherit"
              sx={{ fontWeight: 600 }}
            >
              Integrations
            </Typography>{' '}
            to enable Theo actions for this ticket.
          </>
        ) : (
          <>
            No productivity applications integrated for this customer. Connect Microsoft 365 or Google Workspace in{' '}
            <Typography
              component="span"
              variant="inherit"
              sx={{ fontWeight: 600 }}
            >
              Integrations
            </Typography>{' '}
            to enable their actions.
          </>
        )}
      </Typography>
    </Box>
  );
};

export default ProductivityAppsWarningBanner;
